<p-dialog header="QIQ Prompt Library" class="header prompt-lib-dialog" [(visible)]="showdialog" [modal]="true" [style]="{ width: '70vw', minWidth: '350px' }" [draggable]="false"
    [resizable]="false" (onHide)="onClose()">

    <!-- Loader Overlay -->
    <div *ngIf="isLoading" class="loader-overlay">
        <p-progressSpinner></p-progressSpinner>
    </div>

    <!-- Prompt Selection -->
    <div class="prompt-dialog-body">
        <div class="flex-grow content-container">
            <div class="flex flex-column mb-4">
              <span class="flex justify-content-start queryStyle mb-2">
                Select a System Prompt
              </span>
              <div class="flex flex-row align-items-center">
                <p-dropdown
                  [options]="promptOptions"
                  [(ngModel)]="selectedPrompt"
                  optionLabel="label"
                  optionValue="name"
                  placeholder="Select a Prompt"
                  (onChange)="onPromptChange($event)"
                  [style]="{width: '100%'}">
                  <ng-template let-option pTemplate="item">
                    <div class="prompt-dropdown-item">
                      <div class="prompt-label">{{ option.label }}</div>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
            </div>
            <div class="flex flex-column">
              <div class="flex flex-row align-items-center justify-content-between mb-2">
                <span class="queryStyle">
                  Prompt Content
                </span>
                <div class="flex align-items-center" *ngIf="showUnsavedWarning">
                  <i class="pi pi-exclamation-triangle text-yellow-500 mr-2"></i>
                  <small class="text-yellow-500">Unsaved changes</small>
                </div>
              </div>
              <div class="textarea-container">
                <textarea
                  rows="20"
                  cols="80"
                  pInputTextarea
                  [(ngModel)]="promptContent"
                  (ngModelChange)="onContentChange()"
                  [readonly]="false">
                </textarea>
              </div>
            </div>
        </div>
        <!-- Button Container -->
        <div class="button-container">
          <div class="flex flex-row justify-content-between align-items-center">
            <div class="reset-btn-container">
              <button
                type="button"
                (click)="resetPromptContent()"
                class="p-button qiq-reset-btn"
                [disabled]="isLoading"
              >
                <i class="pi pi-refresh mr-2"></i>
                Reset
              </button>
            </div>
            <div class="qiq-action-buttons">
              <button type="button" (click)="onClose()" class="p-button p-button-label qiq-cancel-btn">Cancel</button>
              <button type="button" (click)="saveSettings()" class="p-button p-button-primary qiq-save-btn">Save</button>
            </div>
          </div>
        </div>
    </div>

</p-dialog>
